import { Link } from "react-router-dom";
import { Mail, Phone, MessageSquare, MapPin } from "lucide-react";
import Logo from "@/components/Logo";
import { CONTACT } from "@/components/ContactCards";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#1E3A6E]/50 bg-[#030F26]">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:px-10 lg:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
              Dice International LLC is a Dubai-based ship brokerage focused on vessel Sale &amp; Purchase and
              responsible, HKC-compliant Demolition &amp; Green Ship Recycling — serving owners, cash buyers and
              yards worldwide with discretion.
            </p>
            <p className="mt-6 font-mono text-xs uppercase tracking-[0.3em] text-[#C5A059]">
              Dubai · Jumeirah Lake Towers
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono text-[0.65rem] uppercase tracking-[0.3em] text-slate-500">Services</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link data-testid="footer-sp-link" to="/sale-and-purchase" className="text-slate-300 transition-colors duration-300 hover:text-[#C5A059]">
                  Sale &amp; Purchase
                </Link>
              </li>
              <li>
                <Link data-testid="footer-demolition-link" to="/demolition-recycling" className="text-slate-300 transition-colors duration-300 hover:text-[#C5A059]">
                  Demolition &amp; Recycling
                </Link>
              </li>
              <li>
                <Link data-testid="footer-about-link" to="/about" className="text-slate-300 transition-colors duration-300 hover:text-[#C5A059]">
                  About the House
                </Link>
              </li>
              <li>
                <Link data-testid="footer-contact-link" to="/contact" className="text-slate-300 transition-colors duration-300 hover:text-[#C5A059]">
                  Contact &amp; Enquiries
                </Link>
              </li>
            </ul>
          </div>
          <div className="lg:col-span-4">
            <p className="font-mono text-[0.65rem] uppercase tracking-[0.3em] text-slate-500">Reach the Desk</p>
            <ul className="mt-5 space-y-4 text-sm">
              <li>
                <a data-testid="footer-email-link" href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-slate-300 transition-colors duration-300 hover:text-[#C5A059]">
                  <Mail className="h-4 w-4 shrink-0 text-[#C5A059]" /> {CONTACT.email}
                </a>
              </li>
              <li>
                <a data-testid="footer-phone-link" href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 text-slate-300 transition-colors duration-300 hover:text-[#C5A059]">
                  <Phone className="h-4 w-4 shrink-0 text-[#C5A059]" /> {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a data-testid="footer-whatsapp-link" href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-slate-300 transition-colors duration-300 hover:text-[#C5A059]">
                  <MessageSquare className="h-4 w-4 shrink-0 text-[#C5A059]" /> WhatsApp {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a data-testid="footer-office-link" href={CONTACT.mapsUrl} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-slate-300 transition-colors duration-300 hover:text-[#C5A059]">
                  <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#C5A059]" />
                  <span>{CONTACT.address}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-[#1E3A6E]/40 pt-8 sm:flex-row sm:items-center">
          <p className="font-mono text-xs text-slate-500">
            © {new Date().getFullYear()} Dice International LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <p className="font-mono text-xs tracking-[0.25em] text-slate-600">S&amp;P · RECYCLING · DUBAI</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
